import api from "../../services/api";
import {
  GET_CURRENT_BOOKING_SLOTS_FAILURE,
  GET_CURRENT_BOOKING_SLOTS_REQUEST,
  GET_CURRENT_BOOKING_SLOTS_SUCCESS,
  UPDATE_BOOKING_SLOT_FAILURE,
  UPDATE_BOOKING_SLOT_REQUEST,
  UPDATE_BOOKING_SLOT_SUCCESS,
} from "./ActionType";

const getCurrentBookingSlotsRequest = () => {
  return {
    type: GET_CURRENT_BOOKING_SLOTS_REQUEST,
  };
};

const getCurrentBookingSlotsSuccess = (slots) => {
  return {
    type: GET_CURRENT_BOOKING_SLOTS_SUCCESS,
    payload: slots,
  };
};

const getCurrentBookingSlotsFailure = (error) => {
  return {
    type: GET_CURRENT_BOOKING_SLOTS_FAILURE,
    payload: error,
  };
};

export const getCurrentBookingSlots = () => {
  return async (dispatch) => {
    dispatch(getCurrentBookingSlotsRequest());
    try {
      const response = await api.get("/booking-slot/current");
      dispatch(getCurrentBookingSlotsSuccess(response.data));
    } catch (error) {
      dispatch(getCurrentBookingSlotsFailure(error.message));
    }
  };
};

const updateBookingSlotRequest = () => {
  return {
    type: UPDATE_BOOKING_SLOT_REQUEST,
  };
};

const updateBookingSlotSuccess = (slots) => {
  return {
    type: UPDATE_BOOKING_SLOT_SUCCESS,
    payload: slots,
  };
};

const updateBookingSlotFailure = (error) => {
  return {
    type: UPDATE_BOOKING_SLOT_FAILURE,
    payload: error,
  };
};

export const updateBookingSlot = (slot) => {
  return async (dispatch) => {
    dispatch(updateBookingSlotRequest());
    try {
      const response = await api.put(`/booking-slot/${slot.id}`, slot);
      dispatch(updateBookingSlotSuccess(response.data));
    } catch (error) {
      dispatch(updateBookingSlotFailure(error.message));
    }
  };
};
